<template>
    <b-modal
        v-model="showModal"
        centered
        content-class="rounded-xl"
        dialog-class="max-w-500-px"
        header-class="border-white-smoke-5 p-0"
        hide-footer
        no-close-on-backdrop
        scrollable
        @hidden="handlePopupHidden"
    >
        <template #modal-header>
            <div
                class="
                    p-3
                    d-flex
                    w-100
                    justify-content-between
                    align-items-center
                "
            >
                <span class="text-semi-xl text-blue-dianne font-weight-600">
                    {{ $t('popup_reminder.title') }}
                </span>
                <b-button
                    class="p-0 h-30-px w-30-px"
                    variant="transparent"
                    @click="showModal = false"
                >
                    <i
                        class="
                            far
                            fa-times
                            text-lg
                            font-weight-bold
                            text-grey
                            icon-square
                        "
                    ></i>
                </b-button>
            </div>
        </template>
        <div class="d-flex flex-column gap-y-4">
            <UnrenewedServiceList
                v-if="unrenewedServices.length"
                :items="unrenewedServices"
            ></UnrenewedServiceList>
            <UnpaidInvoiceList
                v-if="unpaidInvoices.length"
                :items="unpaidInvoices"
            ></UnpaidInvoiceList>
        </div>
        <b-button
            block
            class="
                border-0
                rounded-xl
                text-white
                px-4
                py-2s
                h-48-px
                mt-3
                btn-cinnabar
                font-weight-600
            "
            @click="showModal = false"
        >
            {{ $t('button.i_got_it') }}
        </b-button>
    </b-modal>
</template>

<script>
import UnpaidInvoiceList from '@/components/ScheduledRemindersPopup/components/UnpaidInvoiceList/UnpaidInvoiceList';
import UnrenewedServiceList from '@/components/ScheduledRemindersPopup/components/UnrenewedServiceList/UnrenewedServiceList';
import { getReminders } from '@/services/user.service';
import isEmpty from 'lodash/isEmpty';
import { debounce } from 'vue-debounce';
import { mapGetters } from 'vuex';

export default {
    name: 'ScheduledRemindersPopup',
    components: { UnpaidInvoiceList, UnrenewedServiceList },
    data() {
        return {
            showModal: false,
            reminderData: {},
        };
    },
    computed: {
        ...mapGetters('auth', ['user']),
        loggedIn() {
            return !isEmpty(this.user);
        },
        popupReminderCookieName() {
            if (!this.loggedIn) {
                return;
            }
            const { username } = this.user;
            return `1byte_reminders_popup_${username}_showed_at`;
        },
        unrenewedServices() {
            return this.reminderData.services || [];
        },
        unpaidInvoices() {
            return this.reminderData.orders || [];
        },
        shouldShowPopupReminder() {
            return Boolean(
                this.unrenewedServices.length || this.unpaidInvoices.length
            );
        },
    },
    watch: {
        loggedIn: {
            immediate: true,
            handler() {
                this.handleShowPopup();
            },
        },
        $route: {
            immediate: true,
            handler() {
                this.handleShowPopup();
            },
        },
        shouldShowPopupReminder(value) {
            this.showModal = value;
        },
    },
    methods: {
        getPopupReminderCookieValue() {
            if (!this.popupReminderCookieName) {
                return;
            }
            return this.$cookies.get(this.popupReminderCookieName)?.trim();
        },
        shouldFetchReminderData() {
            if (!this.loggedIn) {
                return false;
            }
            const cookieValue = this.getPopupReminderCookieValue();
            const moment = this.$moment(+cookieValue);
            if (!cookieValue || !moment.isValid()) {
                return true;
            }
            return !moment.isSame(new Date(), 'day');
        },
        handleShowPopup: debounce(async function () {
            if (!this.shouldFetchReminderData()) {
                return;
            }
            try {
                const { data } = await getReminders();
                this.reminderData = data;
                this.setPopupReminderCookie();
            } catch (e) {
                console.error(e);
            }
        }, 1000),
        setPopupReminderCookie() {
            const value = Date.now();
            const domain = process.env.VUE_APP_DOMAIN;
            this.$cookies.set(
                this.popupReminderCookieName,
                value,
                '1d',
                '/',
                domain
            );
        },
        handlePopupHidden() {
            this.reminderData = {};
        },
    },
};
</script>
